export const ENV_VARS_QUERY_KEY = "env-vars";

export interface EnvVar {
  id: number;
  key: string;
  value_suffix: string | null;
  is_empty: boolean;
  created_at: string;
  updated_at: string;
}

export interface WorkspaceEnvVar extends EnvVar {
  workspace_id: number;
}

export interface ToolEnvVar extends EnvVar {
  tool_registry_id: number;
}

export interface WorkspaceScope {
  scope: "workspace";
  workspaceId: number;
}

export interface ToolScope {
  scope: "tool";
  workspaceId: number;
  toolId: number;
}

export type EnvVarScope = WorkspaceScope | ToolScope;

export const queryKeyForScope = (scope: EnvVarScope): (string | number)[] =>
  scope.scope === "workspace"
    ? [ENV_VARS_QUERY_KEY, "workspace", scope.workspaceId]
    : [ENV_VARS_QUERY_KEY, "tool", scope.workspaceId, scope.toolId];
